export default __webpack_public_path__ + "77171d8f5b5283f9d47a3434704bf944.ttf";